import { useAuth0 } from "@appretio/auth";
import { ProgressSpinner, semanticThemeTokens } from "@appretio/ui-kit";
import { Outlet } from "react-router-dom";

interface AuthGuardProps {
  /**
   * Fallback component to render when the user is not authenticated.
   */
  fallback: React.ReactNode;
}

export function AuthGuard({ fallback }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
          background: semanticThemeTokens.backgroundGradient[1],
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <ProgressSpinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return fallback;
  }

  return <Outlet />;
}
